import {
  GET_TRANSACTIONS,
  TRANSACTIONS_FAILED,
  GET_SUCCESSFUL,
  SET_TOTAL,
  SET_TOTAL_SUCCESSFUL,
  GET_PENDING_TRANSACTIONS,
} from "../actions/types";

const initialState = {
  transaction: null,
  transactions: [],
  userTransactions: [],
  successfulTransactions: [],
  pendingTransactions: [],
  totalVolume: "",
  totalSuccessful: "",
  loading: true,
};

export default function transactionsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_TRANSACTIONS:
      return {
        ...state,
        transactions: payload,
        loading: false,
      };
    case GET_SUCCESSFUL:
      return {
        ...state,
        successfulTransactions: payload,
        loading: false,
      };
    case SET_TOTAL:
      return {
        ...state,
        totalVolume: payload,
        loading: false,
      };
    case SET_TOTAL_SUCCESSFUL:
      return {
        ...state,
        totalSuccessful: payload,
        loading: false,
      };
    case TRANSACTIONS_FAILED:
      return {
        ...state,
        transactions: [],
      };
    case GET_PENDING_TRANSACTIONS:
      return {
        ...state,
        pendingTransactions: payload,
        loading: false,
      };
    default:
      return state;
  }
}
